import { createSourceForServerOnly } from 'generated/hypertune'
import { VercelEdgeConfigInitDataProvider } from 'hypertune'
import { createClient } from '@vercel/edge-config'
import { IS_PROD } from 'constants/envs'
import { REFRESH_INTERVAL_MS } from 'lib/hypertune/constants'
import { Language } from 'types/language'
import { ReadonlyRequestCookies } from 'next/dist/server/web/spec-extension/adapters/request-cookies'
import hypertuneLib from 'lib/hypertune/index'

const hypertuneSource = createSourceForServerOnly({
  token: process.env.NEXT_PUBLIC_HYPERTUNE_TOKEN!,
  initDataRefreshIntervalMs: REFRESH_INTERVAL_MS,
  initDataProvider:
    process.env.EDGE_CONFIG && process.env.EDGE_CONFIG_HYPERTUNE_ITEM_KEY
      ? new VercelEdgeConfigInitDataProvider({
          edgeConfigClient: createClient(process.env.EDGE_CONFIG),
          itemKey: process.env.EDGE_CONFIG_HYPERTUNE_ITEM_KEY
        })
      : undefined
})

const getHypertune = async ({ lng, cookies }: { lng: Language; cookies: ReadonlyRequestCookies }) => {
  await hypertuneSource.initIfNeeded() // Check for flag updates
  const anonymousId = hypertuneLib.getAnonymousId(cookies) ?? ''

  return hypertuneSource.root({
    args: {
      context: {
        environment: IS_PROD ? 'production' : 'test',
        user: { id: anonymousId, language: lng }
      }
    }
  })
}

export default getHypertune
